import {Entity} from 'app/core/main.entity';

export class Location extends Entity {
  longitude: number;
  latitude: number;
}
